/**
 * Landing Page
 *
 * Minimal sign-in page per ADR-CEN-12:
 * "Only sign-in button, no feature discovery or public content."
 *
 * Auth0 loginWithRedirect() on button click.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useAuth } from '@lib/auth'
import { useEffect } from 'react'

export const Route = createFileRoute('/')({
  component: LandingPage,
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    return {
      redirect: search.redirect as string | undefined,
    }
  },
})

function LandingPage() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth()
  const navigate = useNavigate()
  const { redirect } = Route.useSearch()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: (redirect ?? '/dashboard') as string })
    }
  }, [isLoading, isAuthenticated, navigate, redirect])

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-black">
        <div className="font-mono text-neutral-400 text-sm animate-pulse">
          Loading...
        </div>
      </div>
    )
  }

  if (isAuthenticated) {
    return null
  }

  return (
    <div className="h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <h1 className="font-mono text-white text-3xl font-bold mb-8">
          Ashkern Inc.
        </h1>
        <button
          onClick={() => loginWithRedirect()}
          className="font-mono px-6 py-3 bg-white text-black font-semibold hover:bg-neutral-200 transition-colors"
        >
          Sign In
        </button>
      </div>
    </div>
  )
}
